import { render, staticRenderFns } from "./IAdd.vue?vue&type=template&id=19b17b58&scoped=true&"
import script from "./IAdd.vue?vue&type=script&lang=js&"
export * from "./IAdd.vue?vue&type=script&lang=js&"
import style0 from "./IAdd.vue?vue&type=style&index=0&id=19b17b58&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b17b58",
  null
  
)

export default component.exports